import { Separator } from '@/components/ui/Separator.tsx';
import BankAccountsSection from '@/features/dashboard/paymentConfig/components/BankAccountsSection.tsx';
import CashInstructionSection from '@/features/dashboard/paymentConfig/components/CashInstructionSection.tsx';
import TpaySection from '@/features/dashboard/paymentConfig/components/TpaySection.tsx';

const PaymentConfig = () => {
  return (
    <div className="space-y-8">
      <TpaySection />

      <Separator />

      <BankAccountsSection />

      <Separator />

      <CashInstructionSection />
    </div>
  );
};

export default PaymentConfig;
